import { render, staticRenderFns } from "./OwnershipHistory.vue?vue&type=template&id=354b3a62&"
import script from "./OwnershipHistory.vue?vue&type=script&lang=js&"
export * from "./OwnershipHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports